export default __webpack_public_path__ + "static/media/transaction_done_Icon.17833b41.svg";